import {combineReducers} from "redux";

import Places from './Places';
import Cities from './Cities';

const AppReducer = combineReducers({
    Places,
    Cities
});

export default AppReducer;
